import ReservationBuilderDispatcher from "../dispatcher/ReservationBuilderDispatcher";
import ReservationBuilderConstants from "../constants/ReservationBuilderConstants";
import DateHelper from "../../DateHelper/DateHelper";
import {
  parseISO,
  formatISO,
} from "date-fns";
import ReservationBuilderHelper from "../ReservationBuilderHelper";

var objectAssign = require("object-assign");
var EventEmitter = require("events").EventEmitter.prototype;
var ReservationBuilderStore = objectAssign({}, EventEmitter, {
  _state: {
    add_ons: [],
    add_ons_reservation_segment_id: "",
    accommodations: [],
    additional_customer_fields: [],
    currency: {
      id: "USD|$|1",
      name: "United States Dollar",
      iso_code: "USD",
      symbol: "$",
      exchange_rate: 1,
    },
    existing_reservation_id: null,
    forms: [],
    form_titles: [],
    cards: [],
    default_payment_gateway: null,
    guest_types: [],
    payment_gateways: [],
    reservation: null,
    seasons: [],
    promo_code: "",
    /* variables that drive the widget */
    accommodation_with_visible_rates: null,
    active_segment_id: null,
    check_in_date: "",
    check_out_date: "",
    did_init: false,
    products: [],
    errors: [],
    card_errors: [],
    group_contract: null,
    loading: false,
    current_maximum_stay: null,
    current_minimum_stay: null,
    master_reservation_id: null,
    maximum_stay: null,
    minimum_stay: null,
    guests: [],
    next_btn: null,
    prev_btn: null,
    room_type_id: null,
    step: ReservationBuilderConstants.ACCOMMODATIONS,
    source_id: null,
    source_type: null,
    validate_group_contract_path: "",
    booking_folio_items_data_table_path: "",
    taken_room_groups: [],
    rating_answers: [],
    emoji_answers: [],
    reservation_segment_booking_amout_update_path: null,
    voucher: null,
    incrementCardElementKey: false,
    form_field_address_field_id: "",
    date_range_picker_visible: false, 
    type_of_booking: 'nightly',
    show_daily_rentals: 'false'
  },

  /**
   * Event Listener, Event Emitter
   */
  emitChange: function (callback) {
    this.emit(ReservationBuilderConstants.CHANGE_EVENT);
    this._state.forceUpdate = false;
    if (typeof callback === "function") {
      callback();
    }
  },

  /**
   * @param {function} callback
   */
  addChangeListener: function (callback) {
    this.on(ReservationBuilderConstants.CHANGE_EVENT, callback);
  },

  /**
   * @param {function} callback
   */
  removeChangeListener: function (callback) {
    this.removeListener(ReservationBuilderConstants.CHANGE_EVENT, callback);
  },

  /*
   * Initializes the store merging the options
   *
   * @param {object} opts
   */
  init: function (opts) {
    for (var i in opts) {
      if (opts[i]) {
        this._state[i] = opts[i];
      }
    }

    // existing reservation?
    this._state.reservation_segment_booking_amout_update_path =
      opts.reservation_segment_booking_amout_update_path;
    if (
      this._state.reservation &&
      this._state.reservation.id &&
      this._state.reservation.reservation_segments &&
      this._state.reservation.reservation_segments.length
    ) {
      this._state.existing_reservation = $.extend(
        true,
        {},
        this._state.reservation
      );
      this._state.existing_reservation_id = this._state.reservation.id;
      this._state.existing_reservation_segments =
        this._state.reservation.reservation_segments.slice();
      this._state.existing_reservation_segment_ids =
        this._state.existing_reservation_segments.map(function (s) {
          return s.id;
        });
    }

    // calculate min/max stay
    this._state.current_minimum_stay = this.calculateMinimumStay(
      new Date(this._state.check_in_date),
      new Date(this._state.check_out_date)
    );

    var guest_types = [];

    for (
      var i = 0,
        ilen = opts.guest_types.sort((a, b) => a.position - b.position).length;
      i < ilen;
      i++
    ) {
      var guest_type = { ...opts.guest_types[i] };

      // first guest type is the default of 2
      if (i == 0) {
        guest_type.number_of_guests = 2;
      } else {
        guest_type.number_of_guests = 0;
      }

      guest_types.push(guest_type);
    }

    this._state.guests = guest_types;
    this._state.did_init = true;
    this.refreshAvailableAccommodations();
  },

  /**
   * Adds a card
   */
  addCard: function (card) {
    this._state.reservation.card_id = null;
    this._state.reservation.payment_method = card;
    this.emitChange();
  },

  /**
   * Adds a ReservationSegment to the Reservation
   */
  addReservationSegment: function (
    room_type,
    check_in_date,
    check_out_date,
    rate,
    quantity
  ) {
    var reservation_segment_guest_types = [];
    if (this._state.guests && this._state.guests.length > 0) {
      this._state.guests.map((guest) => {
        reservation_segment_guest_types.push({
          guest_type_id: guest.id,
          number_of_guests: guest.number_of_guests,
        });
      });
    }

    for (var i = 0; i < quantity; i++) {
      var segment_id = room_type.reservation_segment_id || this.makeId();

      // ensure we have reservation_dates before looping
      if (
        this._state.reservation &&
        !this._state.reservation.reservation_segments
      ) {
        this._state.reservation.reservation_segments = [];
      }

      this._state.reservation.reservation_segments.unshift({
        id: segment_id,
        check_in_date: check_in_date,
        check_out_date: check_out_date,
        reservation_segment_guest_types: reservation_segment_guest_types,
        notes: "",
        room_type: room_type,
        rate_id: rate ? rate.id : null,
        room_id: null,
      });

      this._state.active_segment_id = segment_id;
      this._state.add_ons_reservation_segment_id = segment_id;
    }

    this._state.loading = true;
    this.calculatePricing(false).then(() => {
      this.refreshAvailableAccommodations();
    });
  },

  /**
   * Applies a group_contract to the booking
   */
  applyGroupContract: function (group_contract) {
    if (group_contract) {
      this._state.group_contract = group_contract;
      this._state.check_in_date = group_contract.start_date;
      this._state.check_out_date = group_contract.end_date;
    } else {
      this._state.group_contract = null;
    }
  },



  changeTypeOfBooking: function(type_of_booking) {
    this._state.type_of_booking = type_of_booking;
    this.refreshAvailableAccommodations();

  },

  cardElementKeyIncremented: function () {
    this._state.incrementCardElementKey = false;
    this.emitChange();
  },

  /**
   * Makes an AJAX call to calculate pricing
   */
  calculatePricing: function (rebuild_session, return_session) {
    var self = this;
    var customer_answers = [];

    if (
      this._state.reservation.customer &&
      this._state.reservation.customer.answers &&
      this._state.reservation.customer.answers.length
    ) {
      customer_answers = [...this._state.reservation.customer.answers];
    }

    var { reservation } = this._state;

    // set add_ons
    for (
      var i = 0, ilen = reservation.reservation_segments.length;
      i < ilen;
      i++
    ) {
      var reservation_segment = reservation.reservation_segments[i];
      var add_ons = this.getAddOnsForReservationSegment(reservation_segment);
      reservation_segment.add_ons = add_ons;
    }
    var promise = new Promise(function (resolve, reject) {
      $.ajax({
        type: "POST",
        url: "/admin/reservations/calculate-pricing",
        data: {
          reservation: { ...reservation, taxes_and_fees_totals: [] },
          group_contract_id: self._state.group_contract
            ? self._state.group_contract.id
            : null,
          check_in_date: self._state.check_in_date,
          check_out_date: self._state.check_out_date,
          rebuild_session: rebuild_session ? rebuild_session : false,
          return_session: return_session ? return_session : false,
        },
      }).done(function (data) {
        if (data && data.errors && data.errors.length == 0) {
          if (self._state.reservation.payment_method) {
            data.payment_method = Object.assign(
              self._state.reservation.payment_method
            );
          }
          if (self._state.reservation.customer) {
            data.customer = Object.assign(self._state.reservation.customer);
            if (self._state.reservation.customer.cards) {
              data.customer.cards = Object.assign(
                self._state.reservation.customer.cards
              );
            }
          }
          if (self._state.reservation.card_id) {
            data.card_id = Object.assign(self._state.reservation.card_id);
          }

          self._state.reservation = data;
          if (
            customer_answers &&
            self._state.reservation &&
            self._state.reservation.customer
          ) {
            self._state.reservation.customer.answers = customer_answers;
          }

          // generate reservation segment ids
          for (
            var i = 0,
              ilen = self._state.reservation.reservation_segments.length;
            i < ilen;
            i++
          ) {
            self._state.reservation.reservation_segments[i].check_in_date =
              parseISO(
                self._state.reservation.reservation_segments[i].check_in_date
              );
            self._state.reservation.reservation_segments[i].check_out_date =
              parseISO(
                self._state.reservation.reservation_segments[i].check_out_date
              );

            if (
              typeof self._state.reservation.reservation_segments[i].notes ===
              "object"
            ) {
              self._state.reservation.reservation_segments[i].notes &&
              self._state.reservation.reservation_segments[i].notes.length
                ? (self._state.reservation.reservation_segments[i].notes =
                    self._state.reservation.reservation_segments[
                      i
                    ].notes[0].note)
                : null;
            }
            if (!self._state.reservation.reservation_segments[i].id) {
              if (self._state.reservation.reservation_segments[i].temp_id) {
                self._state.reservation.reservation_segments[i].id =
                  self._state.reservation.reservation_segments[i].temp_id;
              } else {
                self._state.reservation.reservation_segments[i].id =
                  self.makeId();
              }
            }
            if (
              (self._state.add_ons_reservation_segment_id &&
                self._state.reservation.reservation_segments[i].id ==
                  self._state.add_ons_reservation_segment_id) ||
              !self._state.add_ons_reservation_segment_id
            ) {
              self._state.products =
                self._state.reservation.reservation_segments[
                  i
                ].room_type.products;
            }
          }
          resolve();
        } else {
          reject();
        }
      });
    });

    return promise;
  },

  changeAddOns: function (add_ons) {
    var self = this;

    this._state.add_ons = add_ons;
    this._state.loading = true;
    this.emitChange();

    this.calculatePricing(false).then(function () {
      self._state.loading = false;
      self.emitChange();
    });
  },

  changeAddOnsReservationSegmentId: function (add_ons_reservation_segment_id) {
    var products = [];
    this._state.reservation.reservation_segments.map((res_seg) => {
      if (res_seg.id == add_ons_reservation_segment_id) {
        products = res_seg.room_type.products;
      }
    });

    this._state.add_ons_reservation_segment_id = add_ons_reservation_segment_id;
    this._state.products = products;

    this.emitChange();
  },

  getAddOnsForReservationSegment(reservation_segment) {
    if (this._state.add_ons && this._state.add_ons[reservation_segment.id]) {
      return this._state.add_ons[reservation_segment.id];
    }
  },

  getTypeOfBooking() {
    return this._state.type_of_booking
  },

  changeCardInput: function (card) {
    this._state.reservation.payment_method = card;
    this.emitChange();
  },

  addVoucher: function (voucher) {
    this._state.voucher = voucher;
    this.emitChange();
  },

  changeBookingPaymentAmount: function (amount, id) {
    new Promise((resolve, reject) => {
      this._state.loading = true;
      this.emitChange();
      $.ajax({
        type: "POST",
        url: this._state.reservation_segment_booking_amout_update_path,
        data: {
          segment_id: id,
          amount_due_at_booking: amount,
        },
      }).done((data) => {
        if (data.amount_due_at_booking && data.segment_id || data.amount_due_at_booking == 0 && data.segment_id) {
          this._state.reservation.reservation_segments.find(
            (segment) => segment.id == id
          ).booking_payment_amount = amount;
          this._state.loading = false;
          this.emitChange();
          resolve();
        } else {
          reject();
        }
      });
    });
  },

  setCardErrorsToState: function (cardErrors) {
    if (cardErrors) {
      this._state.card_errors = cardErrors;
      this._state.loading = false;
      this.emitChange();
    } else {
      this._state.card_errors = cardErrors;
      this.emitChange();
    }
  },

  disableCardNameInput: function () {
    this._state.disableCardNameInput = true;
    this._state.displayCardResetButton = true;
    this.emitChange();
  },

  resetCardDetails: function () {
    this._state.disableCardNameInput = false;
    this._state.displayCardResetButton = false;
    this._state.reservation.payment_method = {
      save_card: true,
      payment_type: "card",
      cash_drawer: "",
    };
    this._state.card_errors = {};
    this.emitChange();
  },

  /**
   * Changes the date range
   */
  changeDates: function (check_in_date, check_out_date) {
    this._state.check_in_date = new Date(check_in_date);
    this._state.check_out_date = new Date(check_out_date);
    this._state.current_minimum_stay = this.calculateMinimumStay(
      check_in_date,
      check_out_date
    );

    this.refreshAvailableAccommodations();
  },

  changeGuestTypeCount: function (guest_type_id, number_of_guests) {
    var guests = this._state.guests.slice(0);

    for (var i = 0, ilen = guests.length; i < ilen; i++) {
      if (guest_type_id == guests[i].id) {
        guests[i].number_of_guests = number_of_guests;
      }
    }

    this._state.guests = guests;
    this.refreshAvailableAccommodations();
  },

  clearCustomer: function () {
    if (this._state.reservation) {
      this._state.reservation.customer = null;
      this.emitChange();
    }
  },

  /**
   * Makes request to load a customer's cards
   */
  getCustomerCards: function () {
    var self = this;

    var promise = new Promise(function (resolve, reject) {
      if (
        self._state.reservation &&
        self._state.reservation.customer &&
        self._state.reservation.customer.id
      ) {
        $.ajax({
          type: "POST",
          url: "/admin/customer-cards/" + self._state.reservation.customer.id,
        }).done(function (data) {
          if (data && data.cards && data.cards.length > 0) {
            self._state.reservation.customer.cards = data.cards;

            resolve();
          } else {
            self._state.reservation.payment_method = {
              save_card: true,
              payment_type: "card",
              cash_drawer: "",
            };
            resolve();
          }
        });
      } else {
        if (self._state.cards && self._state.cards.length > 0) {
          self._state.reservation.customer.cards = self._state.cards;
        } else {
          self._state.reservation.payment_method = {
            save_card: true,
            payment_type: "card",
            cash_drawer: "",
          };
        }
        resolve();
      }
    });

    return promise;
  },

  updateSegmentGuestCount: function (segment, guest_type_id, count) {
    var self = this;

    this._state.loading = true;
    this.emitChange();

    if (
      this._state.reservation &&
      this._state.reservation.reservation_segments
    ) {
      for (
        var i = 0, ilen = this._state.reservation.reservation_segments.length;
        i < ilen;
        i++
      ) {
        var seg = this._state.reservation.reservation_segments[i];
        if (seg.id == segment.id) {
          if (
            seg.reservation_segment_guest_types &&
            seg.reservation_segment_guest_types.length
          ) {
            var found_match = false;
            for (
              var j = 0, jlen = seg.reservation_segment_guest_types.length;
              j < jlen;
              j++
            ) {
              if (
                seg.reservation_segment_guest_types[j].guest_type_id ==
                guest_type_id
              ) {
                found_match = true;
                seg.reservation_segment_guest_types[j].number_of_guests = count;
              }
            }
            if (!found_match) {
              seg.reservation_segment_guest_types.push({
                guest_type_id: guest_type_id,
                number_of_guests: count,
              });
            }
          } else {
            seg.reservation_segment_guest_types.push({
              guest_type_id: guest_type_id,
              number_of_guests: count,
            });
          }
        }
      }
    }
    for (
      var i = 0, ilen = this._state.reservation.reservation_segments.length;
      i < ilen;
      i++
    ) {
      var seg = this._state.reservation.reservation_segments[i];
      var guest_types = seg.reservation_segment_guest_types;
      guest_types.map((guest_type) => {});
    }

    var promise = new Promise(function (resolve, reject) {
      $.ajax({
        type: "POST",
        url: "/admin/reservations/update-guest-count",
        data: {
          existing_reservation_segment_ids:
            self._state.existing_reservation_segment_ids,
          reservation: self._state.reservation,
        },
      }).done(function (data) {
        self._state.loading = false;
        if (data && data.errors && data.errors.length == 0) {
          self._state.reservation = data;

          for (
            var i = 0,
              ilen = self._state.reservation.reservation_segments.length;
            i < ilen;
            i++
          ) {
            var seg = self._state.reservation.reservation_segments[i];
            var guest_types = seg.reservation_segment_guest_types;
            guest_types.map((guest_type) => {});
          }

          // generate reservation segment ids
          for (
            var i = 0,
              ilen = self._state.reservation.reservation_segments.length;
            i < ilen;
            i++
          ) {
            if (
              typeof self._state.reservation.reservation_segments[i].notes ===
              "object"
            ) {
              self._state.reservation.reservation_segments[i].notes &&
              self._state.reservation.reservation_segments[i].notes.length
                ? (self._state.reservation.reservation_segments[i].notes =
                    self._state.reservation.reservation_segments[
                      i
                    ].notes[0].note)
                : null;
            }
            if (!self._state.reservation.reservation_segments[i].id) {
              if (self._state.reservation.reservation_segments[i].temp_id) {
                self._state.reservation.reservation_segments[i].id =
                  self._state.reservation.reservation_segments[i].temp_id;
              } else {
                self._state.reservation.reservation_segments[i].id =
                  self.makeId();
              }
            }
          }
          resolve();
        } else {
          reject();
        }
        self.emitChange();
      });
    });

    return promise;
  },

  validateAccommodations: function () {
    var promise = new Promise(function (resolve, reject) {
      var reservation = ReservationBuilderStore._state.reservation;

      if (
        reservation &&
        reservation.reservation_segments &&
        reservation.reservation_segments.length > 0
      ) {
        // make sure all reservation segments have a rate selected
        var rates_selected = true;
        for (
          var i = 0, ilen = reservation.reservation_segments.length;
          i < ilen;
          i++
        ) {
          if (reservation.reservation_segments[i].rate_id == null) {
            rates_selected = false;
            break;
          }
        }
        if (rates_selected) {
          resolve();
          return true;
        } else {
          ReservationBuilderStore._state.errors = [
            I18n.t("please_select_rates_to_continue"),
          ];
          reject();
          return false;
        }
      } else {
        ReservationBuilderStore._state.errors = [
          I18n.t("please_select_accommodations_to_continue"),
        ];
        reject();
        return false;
      }
    });

    return promise;
  },

  validateCustomerInformation: function () {
    ReservationBuilderStore._state.errors = [];
    ReservationBuilderStore._state.card_errors = [];
    var promise = new Promise(function (resolve, reject) {
      var reservation = ReservationBuilderStore._state.reservation;
      if (!reservation.customer) {
        ReservationBuilderStore._state.errors = [
          I18n.t("customer_info_must_be_entered_to_continue"),
        ];
        reject();
        return false;
      } else {
        return Promise.all([
          ReservationBuilderStore.customerExistsOnRes(reservation),
        ]).then((response) => {
          var errors = { header_errors: [] };
          response.forEach((obj) => {
            if (obj.card_errors) {
              errors.card_errors = obj.card_errors;
            } else if (obj.errors && obj.errors.header_errors) {
              obj.errors.header_errors.forEach((error) =>
                errors.header_errors.push(error)
              );
              ReservationBuilderStore._state.errors = obj.errors;
            }
          });
          if (
            errors.header_errors.length ||
            (errors.card_errors && errors.card_errors.length)
          ) {
            ReservationBuilderStore._state.errors = errors.header_errors;
            ReservationBuilderStore._state.card_errors = errors.card_errors;
            reject();
            return false;
          } else {
            resolve();
            return true;
          }
        });
      }
    });
    return promise;
  },

  validateFormFieldAnswers: function () {
    ReservationBuilderStore._state.errors = [];
    ReservationBuilderStore._state.card_errors = [];
    var promise = new Promise(function (resolve, reject) {
      var reservation = ReservationBuilderStore._state.reservation;
      if (!reservation.customer) {
        ReservationBuilderStore._state.errors = [
          I18n.t("customer_info_must_be_entered_to_continue"),
        ];
        reject();
        return false;
      } else {
        return Promise.all([
          ReservationBuilderStore.validateCustomerAnswers(reservation),
        ]).then((response) => {
          var errors = { header_errors: [] };
          response.forEach((obj) => {
            if (obj.card_errors) {
              errors.card_errors = obj.card_errors;
            } else if (obj.errors && obj.errors.header_errors) {
              obj.errors.header_errors.forEach((error) =>
                errors.header_errors.push(error)
              );
              ReservationBuilderStore._state.errors = obj.errors;
            }
          });
          if (
            errors.header_errors.length ||
            (errors.card_errors && errors.card_errors.length)
          ) {
            ReservationBuilderStore._state.errors = errors.header_errors;
            ReservationBuilderStore._state.card_errors = errors.card_errors;
            reject();
            return false;
          } else {
            resolve();
            return true;
          }
        });
      }
    });
    return promise;
  },

  validatePaymentInformation: function () {
    ReservationBuilderStore._state.errors = [];
    ReservationBuilderStore._state.card_errors = [];

    var promise = new Promise();
    return promise;
  },

  paymentMethodCheck: function (reservation) {
    var skipBackendCardValidation = true;

    if (reservation.payment_method && !reservation.card_id) {
      if (reservation.payment_method.name_on_card) {
        skipBackendCardValidation = false;
      } else if (reservation.payment_method.card_number) {
        skipBackendCardValidation = false;
      } else if (reservation.payment_method.exp_date) {
        skipBackendCardValidation = false;
      } else if (reservation.payment_method.security_code) {
        skipBackendCardValidation = false;
      }
    }
    return skipBackendCardValidation;
  },

  customerExistsOnRes: function (reservation) {
    return ReservationBuilderStore.validateCustomer(reservation);
  },

  validateCustomer: function (reservation) {
    ReservationBuilderStore._state.errors = [];

    var data = $.extend({}, reservation.customer);
    return $.ajax({
      type: "POST",
      url: "/admin/customers/validate",
      data: {
        customer: data,
      },
    }).done((data) => {
      return data;
    });
  },

  validateCustomerAnswers: function (reservation) {
    ReservationBuilderStore._state.errors = [];
    var data = $.extend({}, reservation.customer);
    var customer_answers =
      reservation.customer && reservation.customer.answers
        ? reservation.customer.answers
        : [];
    return $.ajax({
      type: "POST",
      url: "/admin/customers/validate-form-field-answers",
      data: {
        customer: data,
        customer_answers: JSON.stringify(customer_answers),
        rating_answers: JSON.stringify(this._state.rating_answers),
        emoji_answers: JSON.stringify(this._state.emoji_answers),
        reservation_builder: true,
      },
    }).done((data) => {
      return data;
    });
  },

  validateReviewSummary: function () {
    var promise = new Promise(function (resolve, reject) {
      ReservationBuilderStore.save()
        .then(function () {
          resolve();
        })
        .catch(function () {
          reject();
        });
    });
    return promise;
  },

  ladda_next_btn: null,

  startButtonLoading: function () {
    if (this._state.next_btn) {
      if (this.ladda_next_btn == null) {
        this.ladda_next_btn = Ladda.create(this._state.next_btn);
      }
      this.ladda_next_btn.start();
    }
    if (this._state.prev_btn) {
      $(this._state.prev_btn).attr("disabled", true);
    }
  },

  stopButtonLoading: function () {
    if (this._state.next_btn) {
      if (this.ladda_next_btn == null) {
        this.ladda_next_btn = Ladda.create(this._state.next_btn);
      }
      this.ladda_next_btn.stop();
    }
    if (this._state.prev_btn) {
      $(this._state.prev_btn).removeAttr("disabled");
    }
  },

  jumptoStep: function (step) {
    $(".modal-body").scrollTop(0);
    if (
      ReservationBuilderStore._state.step ===
        ReservationBuilderConstants.ADD_ONS &&
      (step === ReservationBuilderConstants.ACCOMMODATIONS ||
        step === ReservationBuilderConstants.CUSTOMER_INFORMATION)
    ) {
      // you can always navigate away from add-ons if you want to go to accommodations or guest information
      ReservationBuilderStore._state.errors = [];
      ReservationBuilderStore._state.step = step;
      ReservationBuilderStore._state.loading = false;
      ReservationBuilderStore.stopButtonLoading();
      ReservationBuilderStore.emitChange();
    } else if (
      (step == ReservationBuilderConstants.ACCOMMODATIONS ||
        step === ReservationBuilderConstants.ADD_ONS) &&
      ReservationBuilderStore._state.step ==
        ReservationBuilderConstants.CUSTOMER_INFORMATION
    ) {
      // moving backward, nothing to validate
      ReservationBuilderStore._state.errors = [];
      ReservationBuilderStore._state.step = step;
      ReservationBuilderStore._state.loading = false;
      ReservationBuilderStore.stopButtonLoading();
      ReservationBuilderStore.emitChange();
    } else if (
      (step == ReservationBuilderConstants.ACCOMMODATIONS ||
        step === ReservationBuilderConstants.ADD_ONS) &&
      ReservationBuilderStore._state.step ==
        ReservationBuilderConstants.ADDITIONAL_INFORMATION
    ) {
      // moving backward, nothing to validate
      ReservationBuilderStore._state.errors = [];
      ReservationBuilderStore._state.step = step;
      ReservationBuilderStore._state.loading = false;
      ReservationBuilderStore.stopButtonLoading();
      ReservationBuilderStore.emitChange();
    } else if (
      step == ReservationBuilderConstants.ACCOMMODATIONS &&
      ReservationBuilderStore._state.step ==
        ReservationBuilderConstants.PAYMENT_INFORMATION
    ) {
      // moving backward, nothing to validate
      ReservationBuilderStore._state.errors = [];
      ReservationBuilderStore._state.step = step;
      ReservationBuilderStore._state.loading = false;
      ReservationBuilderStore.stopButtonLoading();
      ReservationBuilderStore.emitChange();
    } else if (
      step == ReservationBuilderConstants.ACCOMMODATIONS &&
      ReservationBuilderStore._state.step ==
        ReservationBuilderConstants.REVIEW_SUMMARY
    ) {
      // moving backward, nothing to validate
      ReservationBuilderStore._state.errors = [];
      ReservationBuilderStore._state.step = step;
      ReservationBuilderStore._state.loading = false;
      ReservationBuilderStore.stopButtonLoading();
      ReservationBuilderStore.emitChange();
    } else if (
      step == ReservationBuilderConstants.ADD_ONS &&
      ReservationBuilderStore._state.step ==
        ReservationBuilderConstants.ACCOMMODATIONS
    ) {
      // moving forward, validate!
      ReservationBuilderStore._state.loading = true;
      ReservationBuilderStore.startButtonLoading();
      ReservationBuilderStore.emitChange();

      ReservationBuilderStore.validateAccommodations()
        .then(function () {
          ReservationBuilderStore._state.errors = [];
          ReservationBuilderStore._state.step = step;
          ReservationBuilderStore._state.loading = false;
          ReservationBuilderStore.stopButtonLoading();
          ReservationBuilderStore.emitChange();
        })
        .catch(function () {
          ReservationBuilderStore._state.loading = false;
          ReservationBuilderStore.stopButtonLoading();
          ReservationBuilderStore.emitChange();
        });
    } else if (
      step == ReservationBuilderConstants.CUSTOMER_INFORMATION &&
      ReservationBuilderStore._state.step ==
        ReservationBuilderConstants.ACCOMMODATIONS
    ) {
      // moving forward, validate!
      ReservationBuilderStore._state.loading = true;
      ReservationBuilderStore.startButtonLoading();
      ReservationBuilderStore.emitChange();

      ReservationBuilderStore.validateAccommodations()
        .then(function () {
          ReservationBuilderStore._state.errors = [];
          ReservationBuilderStore._state.step = step;
          ReservationBuilderStore._state.loading = false;
          ReservationBuilderStore.stopButtonLoading();
          ReservationBuilderStore.emitChange();
        })
        .catch(function () {
          ReservationBuilderStore._state.loading = false;
          ReservationBuilderStore.stopButtonLoading();
          ReservationBuilderStore.emitChange();
        });
    } else if (
      step == ReservationBuilderConstants.ADDITIONAL_INFORMATION &&
      ReservationBuilderStore._state.step ==
        ReservationBuilderConstants.ACCOMMODATIONS
    ) {
      // moving forward, validate!
      ReservationBuilderStore._state.loading = true;
      ReservationBuilderStore.startButtonLoading();
      ReservationBuilderStore.emitChange();
      ReservationBuilderStore.validateAccommodations()
        .then(function () {
          ReservationBuilderStore.validateFormFieldAnswers()
            .then(function () {
              ReservationBuilderStore._state.errors = [];
              ReservationBuilderStore._state.step = step;
              ReservationBuilderStore._state.loading = false;
              ReservationBuilderStore.stopButtonLoading();
              ReservationBuilderStore.emitChange();
            })
            .catch(function () {
              ReservationBuilderStore._state.loading = false;
              ReservationBuilderStore.stopButtonLoading();
              ReservationBuilderStore.emitChange();
            });
        })
        .catch(function () {
          ReservationBuilderStore._state.loading = false;
          ReservationBuilderStore.stopButtonLoading();
          ReservationBuilderStore.emitChange();
        });
    } else if (
      step == ReservationBuilderConstants.PAYMENT_INFORMATION &&
      ReservationBuilderStore._state.step ==
        ReservationBuilderConstants.ACCOMMODATIONS
    ) {
      // moving forward, validate!
      ReservationBuilderStore._state.loading = true;
      ReservationBuilderStore.startButtonLoading();
      ReservationBuilderStore.emitChange();

      ReservationBuilderStore.validateAccommodations()
        .then(function () {
          ReservationBuilderStore.validateCustomerInformation()
            .then(function () {
              ReservationBuilderStore._state.errors = [];
              ReservationBuilderStore._state.step = step;
              ReservationBuilderStore._state.loading = false;
              ReservationBuilderStore.stopButtonLoading();
              ReservationBuilderStore.emitChange();
            })
            .catch(function () {
              ReservationBuilderStore._state.loading = false;
              ReservationBuilderStore.stopButtonLoading();
              ReservationBuilderStore.emitChange();
            });
        })
        .catch(function () {
          ReservationBuilderStore._state.loading = false;
          ReservationBuilderStore.stopButtonLoading();
          ReservationBuilderStore.emitChange();
        });
    } else if (
      step == ReservationBuilderConstants.REVIEW_SUMMARY &&
      ReservationBuilderStore._state.step ==
        ReservationBuilderConstants.ACCOMMODATIONS
    ) {
      // moving forward, validate!
      ReservationBuilderStore._state.loading = true;
      ReservationBuilderStore.startButtonLoading();
      ReservationBuilderStore.emitChange();

      ReservationBuilderStore.validateAccommodations()
        .then(function () {
          ReservationBuilderStore.validateCustomerInformation()
            .then(function () {
              ReservationBuilderStore.validatePaymentInformation()
                .then(function () {
                  ReservationBuilderStore._state.errors = [];
                  ReservationBuilderStore._state.step = step;
                  ReservationBuilderStore._state.loading = false;
                  ReservationBuilderStore.stopButtonLoading();
                  ReservationBuilderStore.emitChange();
                })
                .catch(function () {
                  ReservationBuilderStore._state.loading = false;
                  ReservationBuilderStore.stopButtonLoading();
                  ReservationBuilderStore.emitChange();
                });
            })
            .catch(function () {
              ReservationBuilderStore._state.loading = false;
              ReservationBuilderStore.stopButtonLoading();
              ReservationBuilderStore.emitChange();
            });
        })
        .catch(function () {
          ReservationBuilderStore._state.loading = false;
          ReservationBuilderStore.stopButtonLoading();
          ReservationBuilderStore.emitChange();
        });
    } else if (
      step == ReservationBuilderConstants.CUSTOMER_INFORMATION &&
      ReservationBuilderStore._state.step ==
        ReservationBuilderConstants.REVIEW_SUMMARY
    ) {
      // moving backward, nothing to validate
      ReservationBuilderStore._state.errors = [];
      ReservationBuilderStore._state.step = step;
      ReservationBuilderStore._state.loading = false;
      ReservationBuilderStore.stopButtonLoading();
      ReservationBuilderStore.emitChange();
    } else if (
      step == ReservationBuilderConstants.PAYMENT_INFORMATION &&
      ReservationBuilderStore._state.step ==
        ReservationBuilderConstants.CUSTOMER_INFORMATION
    ) {
      // moving backward, nothing to validate
      ReservationBuilderStore._state.loading = true;
      ReservationBuilderStore.startButtonLoading();
      ReservationBuilderStore.emitChange();

      ReservationBuilderStore.validateCustomerInformation()
        .then(function () {
          ReservationBuilderStore._state.errors = [];
          ReservationBuilderStore._state.step = step;
          ReservationBuilderStore._state.loading = false;
          ReservationBuilderStore.stopButtonLoading();
          ReservationBuilderStore.emitChange();
        })
        .catch(function () {
          ReservationBuilderStore._state.loading = false;
          ReservationBuilderStore.stopButtonLoading();
          ReservationBuilderStore.emitChange();
        });
    } else if (
      step == ReservationBuilderConstants.ACCOMMODATIONS &&
      ReservationBuilderStore._state.step ==
        ReservationBuilderConstants.PAYMENT_INFORMATION
    ) {
      // moving backward, nothing to validate
      ReservationBuilderStore._state.errors = [];
      ReservationBuilderStore._state.step = step;
      ReservationBuilderStore._state.loading = false;
      ReservationBuilderStore.stopButtonLoading();
      ReservationBuilderStore.emitChange();
    } else if (
      step == ReservationBuilderConstants.CUSTOMER_INFORMATION &&
      ReservationBuilderStore._state.step ==
        ReservationBuilderConstants.PAYMENT_INFORMATION
    ) {
      // moving backward, nothing to validate
      ReservationBuilderStore._state.errors = [];
      ReservationBuilderStore._state.step = step;
      ReservationBuilderStore._state.loading = false;
      ReservationBuilderStore.stopButtonLoading();
      ReservationBuilderStore.emitChange();
    } else if (
      step == ReservationBuilderConstants.REVIEW_SUMMARY &&
      ReservationBuilderStore._state.step ==
        ReservationBuilderConstants.PAYMENT_INFORMATION
    ) {
      // moving forward, validate!
      ReservationBuilderStore._state.loading = true;
      ReservationBuilderStore.startButtonLoading();
      ReservationBuilderStore.emitChange();

      ReservationBuilderStore.validatePaymentInformation()
        .then(function () {
          ReservationBuilderStore._state.errors = [];
          ReservationBuilderStore._state.step = step;
          ReservationBuilderStore._state.loading = false;
          ReservationBuilderStore.stopButtonLoading();
          ReservationBuilderStore.emitChange();
        })
        .catch(function () {
          ReservationBuilderStore._state.loading = false;
          ReservationBuilderStore.stopButtonLoading();
          ReservationBuilderStore.emitChange();
        });
    } else if (
      step == ReservationBuilderConstants.REVIEW_SUMMARY &&
      ReservationBuilderStore._state.step ==
        ReservationBuilderConstants.CUSTOMER_INFORMATION
    ) {
      // moving forward, validate!
      ReservationBuilderStore._state.loading = true;
      ReservationBuilderStore.startButtonLoading();
      ReservationBuilderStore.emitChange();

      ReservationBuilderStore.validateCustomerInformation()
        .then(function () {
          ReservationBuilderStore.validatePaymentInformation()
            .then(function () {
              ReservationBuilderStore._state.errors = [];
              ReservationBuilderStore._state.step = step;
              ReservationBuilderStore._state.loading = false;
              ReservationBuilderStore.stopButtonLoading();
              ReservationBuilderStore.emitChange();
            })
            .catch(function () {
              ReservationBuilderStore._state.loading = false;
              ReservationBuilderStore.stopButtonLoading();
              ReservationBuilderStore.emitChange();
            });
        })
        .catch(function () {
          ReservationBuilderStore._state.loading = false;
          ReservationBuilderStore.stopButtonLoading();
          ReservationBuilderStore.emitChange();
        });
    } else if (
      step == ReservationBuilderConstants.REVIEW_SUMMARY &&
      ReservationBuilderStore._state.step ==
        ReservationBuilderConstants.ACCOMMODATIONS
    ) {
      // moving forward, validate!
      // Good through here note to myself, if you are not myself please delete
      ReservationBuilderStore._state.loading = true;
      ReservationBuilderStore.startButtonLoading();
      ReservationBuilderStore.emitChange();

      ReservationBuilderStore.validateAccommodations()
        .then(function () {
          ReservationBuilderStore._state.errors = [];
          ReservationBuilderStore._state.step = step;
          ReservationBuilderStore._state.loading = false;
          ReservationBuilderStore.stopButtonLoading();
          ReservationBuilderStore.emitChange();
        })
        .catch(function () {
          ReservationBuilderStore._state.loading = false;
          ReservationBuilderStore.stopButtonLoading();
          ReservationBuilderStore.emitChange();
        });
    } else if (
      step == ReservationBuilderConstants.PAYMENT_INFORMATION &&
      ReservationBuilderStore._state.step ==
        ReservationBuilderConstants.REVIEW_SUMMARY
    ) {
      // moving backward, nothing to validate
      ReservationBuilderStore._state.errors = [];
      ReservationBuilderStore._state.step = step;
      ReservationBuilderStore._state.loading = false;
      ReservationBuilderStore.stopButtonLoading();
      ReservationBuilderStore.emitChange();
    }
  },

  gotoStep: function (step, direction) {
    $(".modal-body").scrollTop(0);
    switch (ReservationBuilderStore._state.step) {
      case ReservationBuilderConstants.ACCOMMODATIONS:
        if (direction == ReservationBuilderConstants.NEXT) {
          ReservationBuilderStore._state.loading = true;
          ReservationBuilderStore.startButtonLoading();
          ReservationBuilderStore.emitChange();

          ReservationBuilderStore.validateAccommodations()
            .then(function () {
              ReservationBuilderStore._state.errors = [];
              ReservationBuilderStore._state.step = step;
              ReservationBuilderStore._state.loading = false;
              ReservationBuilderStore.stopButtonLoading();
              ReservationBuilderStore.emitChange();
            })
            .catch(function () {
              ReservationBuilderStore._state.loading = false;
              ReservationBuilderStore.stopButtonLoading();
              ReservationBuilderStore.emitChange();
            });
        } else {
          // going 'prev', no need to validate
          ReservationBuilderStore._state.errors = [];
          ReservationBuilderStore._state.step = step;
          ReservationBuilderStore._state.loading = false;
          ReservationBuilderStore.stopButtonLoading();
          ReservationBuilderStore.emitChange();
        }
        break;

      case ReservationBuilderConstants.REVIEW_SUMMARY:
        if (direction == ReservationBuilderConstants.NEXT) {
          ReservationBuilderStore._state.step = step;
          ReservationBuilderStore.emitChange();
        } else {
          // going 'prev', no need to validate
          ReservationBuilderStore._state.errors = [];
          ReservationBuilderStore._state.step = step;
          ReservationBuilderStore._state.loading = false;
          ReservationBuilderStore.stopButtonLoading();
          ReservationBuilderStore.emitChange();
        }
        break;

      default:
        ReservationBuilderStore._state.errors = [];
        ReservationBuilderStore._state.step = step;
        ReservationBuilderStore._state.loading = false;
        ReservationBuilderStore.stopButtonLoading();
        ReservationBuilderStore.emitChange();
        break;

      case ReservationBuilderConstants.CUSTOMER_INFORMATION:
        if (direction == ReservationBuilderConstants.NEXT) {
          ReservationBuilderStore._state.loading = true;
          ReservationBuilderStore.startButtonLoading();
          ReservationBuilderStore.emitChange();

          ReservationBuilderStore.validateCustomerInformation()
            .then(function () {
              ReservationBuilderStore._state.errors = [];
              ReservationBuilderStore._state.step = step;
              ReservationBuilderStore._state.loading = false;
              ReservationBuilderStore.stopButtonLoading();
              ReservationBuilderStore.emitChange();
            })
            .catch(function () {
              ReservationBuilderStore._state.loading = false;
              ReservationBuilderStore.stopButtonLoading();
              ReservationBuilderStore.emitChange();
            });
        } else {
          // going 'prev', no need to validate
          ReservationBuilderStore._state.errors = [];
          ReservationBuilderStore._state.step = step;
          ReservationBuilderStore._state.loading = false;
          ReservationBuilderStore.stopButtonLoading();
          ReservationBuilderStore.emitChange();
        }
        break;

      case ReservationBuilderConstants.ADDITIONAL_INFORMATION:
        if (direction == ReservationBuilderConstants.NEXT) {
          ReservationBuilderStore._state.loading = true;
          ReservationBuilderStore.startButtonLoading();
          ReservationBuilderStore.emitChange();

          ReservationBuilderStore.validateFormFieldAnswers()
            .then(function () {
              ReservationBuilderStore._state.errors = [];
              ReservationBuilderStore._state.step = step;
              ReservationBuilderStore._state.loading = false;
              ReservationBuilderStore.stopButtonLoading();
              ReservationBuilderStore.emitChange();
            })
            .catch(function () {
              ReservationBuilderStore._state.loading = false;
              ReservationBuilderStore.stopButtonLoading();
              ReservationBuilderStore.emitChange();
            });
        } else {
          // going 'prev', no need to validate
          ReservationBuilderStore._state.errors = [];
          ReservationBuilderStore._state.step = step;
          ReservationBuilderStore._state.loading = false;
          ReservationBuilderStore.stopButtonLoading();
          ReservationBuilderStore.emitChange();
        }
        break;

      case ReservationBuilderConstants.PAYMENT_INFORMATION:
        if (direction == ReservationBuilderConstants.NEXT) {
          ReservationBuilderStore._state.loading = true;
          ReservationBuilderStore.emitChange();
          ReservationBuilderStore.validateReviewSummary()
            .then(function () {
              ReservationBuilderStore._state.errors = [];
              ReservationBuilderStore._state.step = step;
              ReservationBuilderStore._state.loading = false;
              ReservationBuilderStore.emitChange();
            })
            .catch(function (step) {
              if (typeof step != "undefined") {
                ReservationBuilderStore._state.step = step;
              }
              ReservationBuilderStore._state.loading = false;
              ReservationBuilderStore.stopButtonLoading();
              ReservationBuilderStore.emitChange();
            });
        } else {
          // going 'prev', no need to validate
          ReservationBuilderStore._state.card_errors = [];
          ReservationBuilderStore._state.step = step;
          ReservationBuilderStore._state.loading = false;
          ReservationBuilderStore.stopButtonLoading();
          ReservationBuilderStore.emitChange();
        }
        break;
    }
  },

  refreshAvailableAccommodations: function (callback) {
    var self = this;
    var number_of_guests = 0;
    this._state.guests.map((guest_type) => {
      number_of_guests += guest_type.number_of_guests;
    });

    const [taken_room_types, taken_room_ids] =
      ReservationBuilderHelper.taken_room_types_and_ids(
        this._state.reservation.reservation_segments,
        this._state.check_in_date,
        this._state.check_out_date
      );

    setTimeout(function () {
      self._state.loading = true;
      self.emitChange();
    }, 0);

    $.ajax({
      type: "POST",
      url: "/api/v1/accommodations/property-accommodations",
      data: {
        check_in_date: formatISO(this._state.check_in_date),
        check_out_date: formatISO(this._state.check_out_date),
        type_of_booking: this._state.type_of_booking,
        group_contract_id: this._state.group_contract
          ? this._state.group_contract.id
          : null,
        number_of_guests: number_of_guests,
        guests: JSON.stringify(
          this._state.guests.map((g) => [g.id, g.number_of_guests])
        ),
        taken_room_types: JSON.stringify(taken_room_types),
        taken_room_ids: JSON.stringify(taken_room_ids),
        promo_code: self._state.promo_code,
      },
    }).done(function (data) {
      if (data && data.master_reservation_id) {
        self._state.master_reservation_id = data.master_reservation_id;
      }

      self._state.accommodations = data;
      self._state.loading = false;
      self.emitChange();

      if (typeof callback === "function") {
        callback();
      }
    });
  },

  refreshDataTable: function () {
    if (parent && parent.refresh_data) {
      parent.refresh_data();
    }
  },

  removeSegment: function (segment_id) {
    var segment = null;
    var self = this;
    var room_group_id = null;
    var taken_room_groups = [...this._state.taken_room_groups];

    self._state.loading = true;
    self.emitChange();

    for (
      var i = 0, ilen = this._state.reservation.reservation_segments.length;
      i < ilen;
      i++
    ) {
      if (this._state.reservation.reservation_segments[i].id === segment_id) {
        if (this._state.reservation.reservation_segments[i].room_group) {
          room_group_id =
            this._state.reservation.reservation_segments[i].room_group.id;
        }

        segment = this._state.reservation.reservation_segments.splice(i, 1);
        break;
      }
    }

    if (
      this._state.reservation.reservation_segments &&
      this._state.reservation.reservation_segments.length
    ) {
      this._state.add_ons_reservation_segment_id =
        this._state.reservation.reservation_segments[
          this._state.reservation.reservation_segments.length - 1
        ].id;
    }

    if (room_group_id) {
      for (var k = 0, klen = taken_room_groups.length; k < klen; k++) {
        if (taken_room_groups[k] == room_group_id) {
          taken_room_groups.splice(k, 1);
          break;
        }
      }
    }

    this._state.taken_room_groups = taken_room_groups;
    this.calculatePricing(true).then(function () {
      self.refreshAvailableAccommodations();
    });
  },

  /**
   * Saves (creates) the reservation
   */
  save: function () {
    var self = this;
    var room_type_segments = {};

    self._state.reservation.reservation_segments.forEach((segment) => {
      if (
        segment.check_in_date < self._state.check_out_date &&
        segment.check_out_date > self._state.check_in_date
      ) {
        if (!segment.room && !segment.room_group) {
          room_type_segments[segment.room_type.id]
            ? (room_type_segments[segment.room_type.id] += 1)
            : (room_type_segments[segment.room_type.id] = 1);
        }
      }
    });

    var { reservation } = this._state;
    reservation.source_type = this._state.source_type;
    reservation.source_id = this._state.source_id;

    // set add_ons
    for (
      var i = 0, ilen = reservation.reservation_segments.length;
      i < ilen;
      i++
    ) {
      var reservation_segment = reservation.reservation_segments[i];
      var add_ons = this.getAddOnsForReservationSegment(reservation_segment);
      reservation_segment.add_ons = add_ons;
    }

    if (self._state.reservation.payment_method) {
      var payment_method = Object.assign(
        {},
        self._state.reservation.payment_method
      );
    }

    var promise = new Promise(function (resolve, reject) {
      $.ajax({
        type: "POST",
        url: "/admin/reservations/save",
        data: {
          existing_reservation_id: self._state.existing_reservation_id,
          existing_reservation_segment_ids:
            self._state.existing_reservation_segment_ids,
          reservation: reservation,
          cancellation_amount: self._state.cancellation_amount,
          cancellation_date: self._state.cancellation_date,
          group_contract_id: self._state.group_contract
            ? self._state.group_contract.id
            : null,
          master_reservation_id: self._state.master_reservation_id,
          customer_answers: JSON.stringify(
            self._state.reservation.customer.answers
          ),
          emoji_answers: JSON.stringify(self._state.emoji_answers),
          rating_answers: JSON.stringify(self._state.rating_answers),
          taken_room_groups: self._state.taken_room_groups,
          room_type_segments: JSON.stringify(room_type_segments),
          voucher_id: self._state.voucher ? self._state.voucher.id : null,
        },
      }).done(function (data) {
        if (data && data.errors && data.errors.length == 0) {
          self._state.reservation = data;
          for (
            var i = 0,
              ilen = self._state.reservation.reservation_segments.length;
            i < ilen;
            i++
          ) {
            self._state.reservation.reservation_segments[i].id = self.makeId();
          }
          self.refreshDataTable();
          resolve();
        } else {
          self._state.errors = data.errors;
          payment_method
            ? (self._state.reservation.payment_method = {
                save_card: true,
                payment_type: "card",
                cash_drawer: "",
              })
            : null;
          payment_method ? (self._state.displayCardResetButton = false) : null;
          payment_method ? (self._state.disableCardNameInput = false) : null;
          payment_method ? (self._state.incrementCardElementKey = true) : null;
          self.emitChange();

          self._state.taken_room_groups = [];
          $(".modal-body").scrollTop(0);
          self.calculatePricing().then(function () {
            self.refreshAvailableAccommodations();
          });
          reject();
        }
      });
    });

    return promise;
  },

  updateSegment: function (segment, calculatePricing) {
    var self = this;
    var taken_room_groups = [...self._state.taken_room_groups];

    if (
      this._state.reservation &&
      this._state.reservation.reservation_segments
    ) {
      for (
        var i = 0, ilen = this._state.reservation.reservation_segments.length;
        i < ilen;
        i++
      ) {
        var seg = this._state.reservation.reservation_segments[i];
        if (seg.id == segment.id) {
          this._state.reservation.reservation_segments[i] = $.extend(
            {},
            seg,
            segment
          );
          if (segment.room === null) {
            this._state.reservation.reservation_segments[i].room_id = null;
            this._state.reservation.reservation_segments[i].room = null;
            this._state.reservation.reservation_segments[i].room_group_id =
              null;
            this._state.reservation.reservation_segments[i].room_group = null;
          }

          this._state.reservation.reservation_segments[i].notes;
        }

        if (
          seg.room_group_id &&
          seg.room_group &&
          seg.room_group_id != seg.room_group.id
        ) {
          const index = taken_room_groups.indexOf(seg.room_group.id);

          if (index > -1) {
            taken_room_groups.splice(index, 1);
          }
          taken_room_groups.push(seg.room_group_id);
        }
      }
      self._state.taken_room_groups = taken_room_groups;
    }

    if (calculatePricing !== false) {
      this.calculatePricing().then(function () {
        self.refreshAvailableAccommodations();
      });
    } else {
      self.emitChange();
      self.refreshAvailableAccommodations();
    }
  },

  /**
   * Getters
   */
  getAddOns: function () {
    return this._state.add_ons;
  },

  getAddOnsReservationSegmentId: function () {
    return this._state.add_ons_reservation_segment_id;
  },

  getAccommodations: function () {
    return this._state.accommodations;
  },

  getAccommodationWithVisibleRates: function () {
    return this._state.accommodation_with_visible_rates;
  },

  getActiveSegmentId: function () {
    return this._state.active_segment_id;
  },

  getFormFields: function () {
    return this._state.form_fields;
  },

  getCurrency: function () {
    return this._state.currency;
  },

  getForms: function () {
    return this._state.forms;
  },

  getFormTitles: function () {
    return this._state.form_titles;
  },

  getRatingAnswers: function () {
    return this._state.rating_answers;
  },

  getEmojiAnswers: function () {
    return this._state.emoji_answers;
  },

  getCards: function () {
    return this._state.cards;
  },

  getCheckInDate: function () {
    return this._state.check_in_date;
  },

  getCheckOutDate: function () {
    return this._state.check_out_date;
  },

  getCurrentMaximumStay: function () {
    return this._state.current_maximum_stay || this._state.maximum_stay;
  },

  getCurrentMinimumStay: function () {
    return this._state.current_minimum_stay || this._state.minimum_stay;
  },

  getDateFormat: function () {
    return this._state.date_format;
  },

  getShowDailyRentals: function () {
    return this._state.show_daily_rentals;
  },

  getDefaultPaymentGateway: function () {
    return this._state.default_payment_gateway;
  },

  getDidInit: function () {
    return this._state.did_init;
  },

  getStripe: function () {
    return this._state.stripe;
  },

  getVoucher: function () {
    return this._state.voucher;
  },

  getCardNameInput: function () {
    return this._state.disableCardNameInput;
  },

  getDisplayCardResetButton: function () {
    return this._state.displayCardResetButton;
  },

  getincrementCardElementKey: function () {
    return this._state.incrementCardElementKey;
  },

  getErrors: function () {
    return this._state.errors;
  },

  getCardErrors: function () {
    return this._state.card_errors;
  },

  getExistingReservation: function () {
    return this._state.existing_reservation;
  },

  getGuestTypes: function () {
    return this._state.guest_types.sort((a, b) => a.position - b.position);
  },

  getGuests: function () {
    return this._state.guests;
  },

  getGroupContract: function () {
    return this._state.group_contract;
  },

  getLoading: function () {
    return this._state.loading;
  },

  getPromoCode: function () {
    return this._state.promo_code;
  },

  getPromoRatesListPath: function () {
    return this._state.promo_rates_list_path;
  },

  getMasterReservationId: function () {
    return this._state.master_reservation_id;
  },

  getPaymentGateways: function () {
    return this._state.payment_gateways;
  },

  getRoomTypeId: function () {
    return this._state.room_type_id;
  },

  getProducts: function () {
    return this._state.products;
  },

  getReservation: function () {
    return this._state.reservation;
  },

  getStep: function () {
    return this._state.step;
  },

  getValidateGroupContractPath: function () {
    return this._state.validate_group_contract_path;
  },

  getBookingFolioItemsDataTablePath: function () {
    return this._state.booking_folio_items_data_table_path;
  },

  getExistingSegments: function () {
    return this._state.existing_segments;
  },

  getFormFieldAddressID: function () {
    return this._state.form_field_address_field_id;
  },

  getDateRangePickerVisible: function () {
    return this._state.date_range_picker_visible;
  },

  /**
   * Generates a random ID
   */
  makeId: function () {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

    for (var i = 0; i < 12; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
  },

  calculateMaximumStay: function (check_in_date, check_out_date, rate) {
    if (rate && rate.maximum_stay && rate.maximum_stay > 0) {
      return rate.maximum_stay;
    }

    if (this._state.maximum_stay !== null) {
      return this._state.maximum_stay;
    } else {
      return 28; //default
    }
  },

  calculateMinimumStay: function (check_in_date, check_out_date) {
    if (this._state.seasons && this._state.seasons.length > 0) {
      for (var i = 0, ilen = this._state.seasons.length; i < ilen; i++) {
        var season = this._state.seasons[i];

        if (season.minimum_stay == null) {
          continue;
        }

        season.start_date = DateHelper.parseDate(season.start_date);
        season.end_date = DateHelper.parseDate(season.end_date);

        if (
          DateHelper.between(
            check_in_date,
            check_out_date,
            season.start_date,
            season.end_date
          )
        ) {
          return season.minimum_stay;
        }
      }
    }

    if (this._state.minimum_stay !== null) {
      return this._state.minimum_stay;
    } else {
      return 1; //default
    }
  },
});

ReservationBuilderStore.dispatchToken = ReservationBuilderDispatcher.register(
  function (payload) {
    switch (payload.action) {
      case ReservationBuilderConstants.INIT:
        ReservationBuilderStore.init(payload.opts);
        break;

      case ReservationBuilderConstants.ADD_CARD:
        ReservationBuilderStore.addCard(payload.card);
        break;

      case ReservationBuilderConstants.CARD_ELEMENT_KEY_INCREMENTED:
        ReservationBuilderStore.cardElementKeyIncremented();
        break;

      case ReservationBuilderConstants.CHANGE_ADD_ONS:
        ReservationBuilderStore.changeAddOns(payload.add_ons);
        break;

      case ReservationBuilderConstants.ADD_VOUCHER:
        ReservationBuilderStore.addVoucher(payload.voucher);
        break;

      case ReservationBuilderConstants.CHANGE_ADD_ONS_RESERVATION_SEGMENT_ID:
        ReservationBuilderStore.changeAddOnsReservationSegmentId(
          payload.add_ons_reservation_segment_id
        );
        break;

      case ReservationBuilderConstants.CHANGE_CARD_INPUT:
        ReservationBuilderStore.changeCardInput(payload.card);
        break;

      case ReservationBuilderConstants.CHANGE_BOOKING_PAYMENT_AMOUNT:
        ReservationBuilderStore.changeBookingPaymentAmount(
          payload.amount,
          payload.id
        );
        break;

      case ReservationBuilderConstants.SET_CARD_ERRORS_TO_STATE:
        ReservationBuilderStore.setCardErrorsToState(payload.cardErrors);
        break;

      case ReservationBuilderConstants.DISABLE_CARD_NAME_INPUT:
        ReservationBuilderStore.disableCardNameInput();
        break;

      case ReservationBuilderConstants.ADD_RESERVATION_SEGMENT:
        ReservationBuilderStore._state.loading = true;
        ReservationBuilderStore._state.errors = [];
        parent.form_changed = true;
        ReservationBuilderStore.emitChange();

        ReservationBuilderStore.addReservationSegment(
          payload.room_type,
          payload.check_in_date,
          payload.check_out_date,
          payload.rate,
          payload.quantity || 1
        );
        break;

      case ReservationBuilderConstants.APPLY_GROUP_CONTRACT:
        ReservationBuilderStore._state.accommodation_with_visible_rates = null;
        ReservationBuilderStore.applyGroupContract(payload.group_contract);
        ReservationBuilderStore.refreshAvailableAccommodations();
        break;

      case ReservationBuilderConstants.CHANGE_DATES:
        ReservationBuilderStore._state.accommodation_with_visible_rates = null;
        ReservationBuilderStore.changeDates(
          payload.check_in_date,
          payload.check_out_date
        );
        break;

      case ReservationBuilderConstants.CHANGE_GUEST_TYPE_COUNT:
        ReservationBuilderStore._state.accommodation_with_visible_rates = null;
        ReservationBuilderStore.changeGuestTypeCount(
          payload.guest_type_id,
          payload.number_of_guests
        );
        break;

      case ReservationBuilderConstants.CHANGE_PROMO_CODE:
        ReservationBuilderStore._state.promo_code = payload.promo_code;

        ReservationBuilderStore.emitChange();
        payload.refreshAccommodations
          ? ReservationBuilderStore.refreshAvailableAccommodations()
          : null;

        break;

      case ReservationBuilderConstants.SUBMIT_PROMO_CODE:
        ReservationBuilderStore.refreshAvailableAccommodations();
        break;

      case ReservationBuilderConstants.CLEAR_CUSTOMER:
        ReservationBuilderStore.clearCustomer();
        parent.form_changed = true;
        break;

      case ReservationBuilderConstants.GOTO_STEP:
        ReservationBuilderStore.gotoStep(payload.step, payload.direction);
        break;

      case ReservationBuilderConstants.JUMPTO_STEP:
        ReservationBuilderStore.jumptoStep(payload.step);
        break;

      case ReservationBuilderConstants.REMOVE_SEGMENT:
        ReservationBuilderStore.removeSegment(payload.segment_id);
        parent.form_changed = true;
        break;

      case ReservationBuilderConstants.RESET_CARD_DETAILS:
        ReservationBuilderStore.resetCardDetails();
        parent.form_changed = true;
        break;

      case ReservationBuilderConstants.SAVE:
        ReservationBuilderStore.save();
        break;

      case ReservationBuilderConstants.CHANGE_TYPE_OF_BOOKING:
        ReservationBuilderStore.changeTypeOfBooking(payload.type_of_booking)
        break;


      case ReservationBuilderConstants.SET_BILLING_POLICY:
        ReservationBuilderStore._state.reservation.billing_policy =
          payload.billing_policy;
        ReservationBuilderStore._state.loading = true;
        ReservationBuilderStore.calculatePricing().then(function () {
          ReservationBuilderStore._state.loading = false;
          ReservationBuilderStore.emitChange();
        });
        break;

      case ReservationBuilderConstants.SET_BUTTONS:
        ReservationBuilderStore._state.prev_btn = payload.prev_btn;
        ReservationBuilderStore._state.next_btn = payload.next_btn;
        break;

      case ReservationBuilderConstants.SET_CUSTOMER:
        ReservationBuilderStore._state.errors = [];
        if (ReservationBuilderStore._state.reservation) {
          if (
            ReservationBuilderStore._state.reservation.customer &&
            payload.customer &&
            ReservationBuilderStore._state.reservation.customer.id !=
              payload.customer.id
          ) {
            ReservationBuilderStore._state.cards = [];
            ReservationBuilderStore._state.reservation.card_id = null;
          }

          setTimeout(function () {
            ReservationBuilderStore._state.loading = true;
            ReservationBuilderStore._state.reservation.customer =
              payload.customer;
            ReservationBuilderStore._state.form_field_address_field_id =
              payload.form_field_address_field_id;
            parent.form_changed = true;
            ReservationBuilderStore.emitChange();
          }, 1);

          setTimeout(function () {
            ReservationBuilderStore.getCustomerCards().then(function () {
              ReservationBuilderStore._state.loading = false;
              ReservationBuilderStore.emitChange();
            });
          }, 1);
        }
        break;

      case ReservationBuilderConstants.SET_VALUE:
        if (payload.name.indexOf(".") == -1) {
          ReservationBuilderStore._state[payload.name] = payload.value;
        } else {
          var names = payload.name.split(".");
          ReservationBuilderStore._state[names[0]][names[1]] = payload.value;
        }

        ReservationBuilderStore.emitChange();
        break;

      case ReservationBuilderConstants.UPDATE_SEGMENT:
        ReservationBuilderStore.updateSegment(
          payload.segment,
          payload.calculatePricing
        );
        break;

      case ReservationBuilderConstants.UPDATE_SEGMENT_GUEST_COUNT:
        ReservationBuilderStore.updateSegmentGuestCount(
          payload.segment,
          payload.guest_type_id,
          payload.count
        );
        break;

      case ReservationBuilderConstants.HIDE_RATES:
        ReservationBuilderStore._state.accommodation_with_visible_rates = null;
        ReservationBuilderStore.emitChange();
        break;

      case ReservationBuilderConstants.VIEW_RATES:
        ReservationBuilderStore._state.accommodation_with_visible_rates =
          payload.accommodation;
        ReservationBuilderStore.emitChange();
        break;

      case ReservationBuilderConstants.CALCULATE_PRICING:
        ReservationBuilderStore._state.loading = true;
        ReservationBuilderStore.calculatePricing(false, true).then(function () {
          ReservationBuilderStore.refreshAvailableAccommodations();
          ReservationBuilderStore._state.loading = false;
          ReservationBuilderStore.emitChange();
        });
        break;

      case ReservationBuilderConstants.SET_EMOJI_STATE:
        ReservationBuilderStore._state.emoji_answers = payload.emoji_answers;
        ReservationBuilderStore.emitChange();
        break;

      case ReservationBuilderConstants.SET_RATING_STATE:
        ReservationBuilderStore._state.rating_answers = payload.rating_answers;
        ReservationBuilderStore.emitChange();
        break;

      case ReservationBuilderConstants.LOADING:
        ReservationBuilderStore._state.loading = payload.loading;
        ReservationBuilderStore.emitChange();
        break;

      case ReservationBuilderConstants.DATE_RANGE_PICKER_VISIBLE:
        ReservationBuilderStore._state.date_range_picker_visible = payload.visible;
        ReservationBuilderStore.emitChange();
        break;

      default:
    }
  }
);

/* silence the EventEmitter */
ReservationBuilderStore.setMaxListeners(0);

export default ReservationBuilderStore;
